import { aktionsfarbenAus, istFarbwert, PALETTE } from "@kundeninfo/ui";

/**
 * Die Textfarbe eines Kürzel-Chips (Kundenliste, Kundenakte) je Farbschema — abgeleitet aus
 * der Markenfarbe des Unternehmens.
 *
 * **Eine Rechnung für alle.** Hier stand bis zur Adjudikation (b) der UV-Abschlussprüfung
 * eine von Hand gemessene Dreiertabelle für BS/ME/PA und daneben ein eigener Rückfall für
 * alles Übrige. Beides war für sich richtig, aber es waren zwei Antworten auf EINE Frage —
 * und die Tabelle widersprach Dirks Entscheid, dass weitere Unternehmen grundsätzlich
 * anlegbar sein müssen: Die drei gesäten Marken bekamen die gemessenen Werte, eine vierte
 * den Rückfall, und dass beide unterschiedlich rechnen, wäre niemandem aufgefallen.
 *
 * Gespeist wird die Farbe deshalb aus `aktionsfarbenAus` — DERSELBEN Rechnung, die auch die
 * Aktions-Tokens der Oberfläche setzt. `aktion` ist der bis zur WCAG-Schwelle abgedunkelte
 * Ton für den Hellmodus, `hellFuerDunkelmodus` die aufgehellte Fassung für den
 * Dunkelmodus. Ein heute angelegtes Unternehmen bekommt damit exakt dieselbe Behandlung wie
 * ein geseedetes.
 *
 * **Sichtbare Folge** (von Dirk freigegeben): `#B75A0E`→`#B85E15` (BS hell),
 * `#588216`→`#567E14` (ME hell), `#7984D7`→`#81829D` (PA dunkel); BS/ME dunkel und PA hell
 * bleiben. Die ersten beiden sind kaum zu sehen, PA im Dunkelmodus schon — die Rechnung
 * behält das Kanalverhältnis der Marke bei und hört auf, sobald die Schwelle erreicht ist,
 * wo das Augenmass der Tabelle ein sattes Fliederblau gewählt hatte.
 *
 * **Warum kein Wurf.** `aktionsfarbenAus` wirft bei allem, was keine Farbe `#rrggbb` ist —
 * beim Sitzungsaufbau soll das laut scheitern. Ein Chip ist dagegen Beiwerk in einer Liste:
 * Ein krummer Wert in einem einzigen Datensatz darf nicht die ganze Kundenliste mitreissen.
 * Deshalb hier vorher `istFarbwert` (dieselbe eine Vorstellung davon, was eine Farbe ist)
 * und im Rückfall der normale Fliesstext des jeweiligen Schemas — genau das Verhalten, das
 * der alte Rückfall über `contrastRatio` auch hatte.
 */
export function markenTextfarben(colorHex: string): { hell: string; dunkel: string } {
  if (!istFarbwert(colorHex)) {
    return { hell: PALETTE.light.text, dunkel: PALETTE.dark.text };
  }
  const farben = aktionsfarbenAus(colorHex);
  return { hell: farben.aktion, dunkel: farben.hellFuerDunkelmodus };
}
